// @flow
import createLocaleLoader from 'app/packages/createLocaleLoader';
import loaderMap from 'locale/loaderMap-lite';

export default createLocaleLoader(loaderMap);
